/// <amd-module name="Analytics/Shared/Common/AnalyticsPage" />
import { AnalyticsDataValidator } from "Analytics/Shared/Common/AnalyticsDataValidator";
import { AnalyticsExtensionValidator } from "Analytics/Shared/Common/AnalyticsExtensionValidator";
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";

export interface IAnalyticsPageProps extends IVssComponentProperties {
    renderHeader: () => JSX.Element;
    getDataValidationPromises: () => Promise<any>[] | undefined;
    onError: (errorText: string) => void;
}

export interface IAnalyticsPageState {
    dataValidationPromises: Promise<any>[] | undefined;
}

export class AnalyticsPage extends VssComponent<IAnalyticsPageProps, IAnalyticsPageState> {
    public constructor(props: IAnalyticsPageProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { dataValidationPromises: [] } as Readonly<IAnalyticsPageState>;
    }

    public render() {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="analytics-page flex-grow absolute-fill">
                    {this.props.renderHeader()}
                    <AnalyticsExtensionValidator onAnalyticsEnabled={this._handleAnalyticsEnabled}>
                        <AnalyticsDataValidator dataValidationPromises={this.state.dataValidationPromises}>
                            <div className="page-content page-content-top flex flex-grow">{this.props.children}</div>
                        </AnalyticsDataValidator>
                    </AnalyticsExtensionValidator>
                </Page>
            </Surface>
        );
    }

    private _handleAnalyticsEnabled = (): void => {
        if (!this.state.dataValidationPromises || this.state.dataValidationPromises.length === 0) {
            this.setState({
                dataValidationPromises: this.props.getDataValidationPromises()
            });
        }
    };
}
